import { createContext, FC, useContext } from 'react';

import { EnvConfig } from '../config/configMapping';

export const ConfigContext = createContext<EnvConfig | undefined>(undefined);

export const ConfigProvider: FC<{ envConfig: EnvConfig; children: React.ReactNode }> = ({ envConfig, children }) => {
  return <ConfigContext.Provider value={envConfig}>{children}</ConfigContext.Provider>;
};

/** Use in application to get access to the configurations */
export const useEnvConfig = (): EnvConfig => {
  const context = useContext(ConfigContext);

  if (context === undefined) {
    throw new Error(`useEnvConfig must be used within an ConfigProvider`);
  }

  return context;
};
